import { autoserialize, autoserializeAs } from 'cerialize';
import { RoleModel } from './role.model';
import { UserModel } from './user.model';

export class TeamMemberModel {
    @autoserialize public _id: string;
    @autoserializeAs(UserModel) public user: UserModel;
    @autoserializeAs(RoleModel) public permissionGroups: RoleModel[] = [];
}
